import { useContent } from '@/content'
import { useDocumentMeta } from '@/hooks'
import { Reveal, Section } from '@/components/ui'
import { ContactDetails } from '@/features/contact'
import { ProfileCard } from '@/features/profile'
import { SocialPanels } from '@/features/social'
import styles from './ContactPage.module.css'

/** Profile panel beside the contact details and map. */
export const ContactPage = () => {
  const { site } = useContent()
  useDocumentMeta({
    title: `Contact - ${site.name}`,
    description: `Get in touch with ${site.owner} about a project.`,
  })

  return (
    <>
      <Section innerClassName={styles.row} aria-labelledby="contact-heading">
        <ProfileCard
          imageAspect="450 / 581"
          headingLevel="h1"
          headingId="contact-heading"
          priority
        />

        <ContactDetails />
      </Section>

      <Reveal>
        <SocialPanels />
      </Reveal>
    </>
  )
}
